import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigServerService } from '../../../core';
import { buildHttpParams } from '../../../core/utils/http-util';
import { ITagListResponse } from '../../environment/tags/interfaces/tag-list-response';
import { ITagRequest } from '../../environment/tags/interfaces/tag-request.interface';
import { ITagResponse } from '../../environment/tags/interfaces/tag-response.interface';
import { ITag } from '../../environment/tags/interfaces/tag.interface';

@Injectable({
  providedIn: 'root',
})
export class TagApi {
  private apiUrl: string;

  constructor(
    private http: HttpClient,
    private configServerService: ConfigServerService
  ) {
    this.apiUrl = `${this.configServerService.getPathApi()}/v1/environment/tags`;
  }

  fetch(filter?: ITagRequest): Observable<ITagResponse> {
    return this.http.get<ITagResponse>(this.apiUrl, {
      params: buildHttpParams(filter),
    });
  }

  fetchList(filter?: ITagRequest): Observable<ITagListResponse> {
    return this.http.get<ITagListResponse>(`${this.apiUrl}/0/list`, {
      params: buildHttpParams(filter),
    });
  }

  getById(id: number): Observable<ITag> {
    return this.http.get<ITag>(`${this.apiUrl}/${id}`);
  }

  create(tag: ITag): Observable<ITag> {
    return this.http.post<ITag>(this.apiUrl, tag);
  }

  update(tag: ITag): Observable<ITag> {
    return this.http.put<ITag>(`${this.apiUrl}/${tag.id}`, tag);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}
